var map = {
	"./1.png": 279,
	"./10.png": 9947,
	"./2.png": 3822,
	"./3.png": 5453,
	"./4.png": 5695,
	"./5.png": 771,
	"./6.png": 5675,
	"./7.png": 1353,
	"./8.png": 8201,
	"./9.png": 6726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 736;